export const fnReturnData = (result) => result.data
